import {
  IContentService,
  ContentService,
} from '@grubhubprod/chiri/dist/core/services/content-service/content-service';
import { APP_CONFIG } from 'src/environment';

interface ChiriContentServiceProperties {
  config: Pick<
    AppConfig,
    'contentfulEnvironment' | 'contentfulCdnUrl' | 'contentfulAccessToken'
  >;
  spaceId: string;
  spaceAccessToken?: string;
  typeMap?: any;
}

export function getChiriContentService(
  props?: ChiriContentServiceProperties,
): IContentService {
  const {
    config = APP_CONFIG,
    spaceId,
    spaceAccessToken,
    typeMap = {},
  } = props;
  return new ContentService({
    environment: config.contentfulEnvironment,
    cdnUrl: config.contentfulCdnUrl,
    accessToken: spaceAccessToken ?? config.contentfulAccessToken,
    spaceId,
    typeMap,
  } as any);
}
